module.exports = __webpack_public_path__ + "static/media/blue-skies-donate-cta.08d99cbf.png";